export default {
  CriarConta: 'criar-conta',
  RecuperarSenha: 'recuperar-senha',
  CadastrarSenha: 'cadastrar-senha',
}
